export function RequestAuthIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 9.5V8.5C7.5 7.11929 8.61929 6 10 6C11.3807 6 12.5 7.11929 12.5 8.5V9.5C13.0523 9.5 13.5 9.94772 13.5 10.5V13C13.5 13.5523 13.0523 14 12.5 14H7.5C6.94772 14 6.5 13.5523 6.5 13V10.5C6.5 9.94772 6.94772 9.5 7.5 9.5ZM11.5 8.5V9.5H8.5V8.5C8.5 7.67157 9.17157 7 10 7C10.8284 7 11.5 7.67157 11.5 8.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3414 3.61414C14.7147 1.99827 12.4736 1 9.99963 1C5.02942 1 1 5.02942 1 10C1 14.9706 5.02942 19 9.99963 19C12.4871 19 14.7391 17.9908 16.368 16.3593C16.368 16.3593 16.8851 15.7788 16.368 15.2541C15.8505 14.7297 15.2598 15.2541 15.2598 15.2541C13.914 16.6014 12.0543 17.4347 9.99954 17.4347C5.89372 17.4347 2.56518 14.1062 2.56518 10C2.56518 5.89381 5.89372 2.56528 9.99954 2.56528C12.0415 2.56528 13.8911 3.38848 15.2346 4.72085L13.9324 6.02303C13.6256 6.32983 13.7319 6.57548 14.1657 6.57548H17.2897C18.0754 6.57548 18.0754 6.57548 18.0754 5.78975V2.66581C18.0754 2.2331 17.8283 2.1272 17.5229 2.43254L16.3414 3.61414Z"
        fill="currentColor"
      />
    </svg>
  );
}
